// Checks to see if the elements on the grid at coordinates a, b and c all equal the same value, defaults to ''
const c = (grid, a, b ,c) => {
  if (grid[a[0]][a[1]] === grid[b[0]][b[1]] && grid[b[0]][b[1]] === grid[c[0]][c[1]]) return grid[a[0]][a[1]];
  else return '';
}

// Returns winner in grid, defaults to ''
export default g => {
  // Check all that go through middle square together since we just return the value in that central square
  if(
    c(g, [0, 0], [1, 1], [2, 2]) || // top left to bottom right
    c(g, [0, 1], [1, 1], [2, 1]) || // across middle
    c(g, [0, 2], [1, 1], [2, 0]) || // bottom left to top right
    c(g, [1, 0], [1, 1], [1, 2])) // down middle
      return g[1][1];
  // Check grid intersections with top left
  else if(
    c(g, [0, 0], [1, 0], [2, 0]) || // top left to top right
    c(g, [0, 0], [0, 1], [0, 2])) // top left to bottom left
    return g[0][0];
  // Check grid intersections with bottom right
  else if(
    c(g, [2, 2], [2, 1], [2, 0]) || // Bottom right to top right
    c(g, [2, 2], [1, 2], [0, 2])) // bottom right to bottom left
    return g[2][2];
  else return ''
}



// WEBPACK FOOTER //
// ./src/Util/calcWin.js